"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUrl = void 0;
var assertFunctions_1 = require("./assertFunctions");
/**
 * URL 格式是否正确
 * @param url 字符串
 */
function isValidUrl(url) {
    assertFunctions_1.assertString(url, "url");
    return url.startsWith("http://") ||
        url.startsWith("https://") ||
        url.startsWith("//");
}
exports.isValidUrl = isValidUrl;
